import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messages'
})
export class MessagesPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
